import { Box, Text, Image, Center } from "@chakra-ui/react";
import teamMembers from "./teamMembers";

export default function WhoWeAre(props) {
  return (
    <div {...props} style={{ paddingTop: "80px" }}>
      <Box
        ml='auto'
        mr='auto'
        width={{ base: "90%", md: "77%", lg: "77%" }}
        borderRadius={3}
      >
        <Center>
          <Text color='white' fontSize='4xl' fontWeight={700}>
            Who We Are
          </Text>
        </Center>
        <Box
          display='flex'
          flexDirection={{ base: "column", md: "row", lg: "row" }}
          alignItems='start'
          justifyContent='space-around'
          flexWrap='wrap'
          background='rgba(31, 159, 181, 0.3)'
          borderRadius={3}
        >
          {teamMembers.map((items) => {
            return (
              <Box
                key={items.id}
                ml={2}
                borderRadius={3}
                width={{ base: "100%", md: "40%", xl: "400px" }}
                textAlign='justify'
                alignItems='center'
              >
                <Box display='flex' flexDirection='row'>
                  <Image
                    src={items.image}
                    alt={items.image}
                    width='200px'
                    borderRadius='50%'
                    marginLeft='auto'
                    marginRight='auto'
                    marginTop={3}
                    marginBottom={3}
                  />
                </Box>
                <Box display='flex' flexDirection='column' pl={3} pr={3} pb={3}>
                  <Text
                    color='white'
                    fontSize='18px'
                    fontWeight={700}
                    textAlign='center'
                    mt={3}
                    mb={3}
                  >
                    {items.name}
                  </Text>

                  <Text color='white' fontSize='14px'>
                    {items.details}
                  </Text>
                </Box>
              </Box>
            );
          })}
        </Box>
      </Box>
    </div>
  );
}
